'kiwi public';

import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import TypingStatusIndicator from './TypingStatusIndicator';
export default {
  components: {
    TypingStatusIndicator: TypingStatusIndicator
  },
  props: ['buffer'],
  computed: {
    users: function users() {
      if (this.buffer.isQuery()) {
        // if this is a query return the target as users
        var network = this.$state.getActiveNetwork();
        var user = this.$state.getUser(network.id, this.buffer.name);
        return user ? _defineProperty({}, user.nick, user) : {};
      }
      return this.buffer.users;
    },
    typingUsers: function typingUsers() {
      var _context,
        _this = this;
      var myNick = this.$state.getActiveNetwork().nick;
      return _filterInstanceProperty(_context = _Object$values(this.users)).call(_context, function (u) {
        return u.nick !== myNick && u.typingStatus(_this.buffer.name).status;
      });
    }
  },
  methods: {
    userColour: function userColour(user) {
      return user && this.buffer.setting('colour_nicknames_in_messages') ? user.getColour() : '';
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["TypingUsersList"]
window._kiwi_exports.components.TypingUsersList = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
